import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["accessibilityLabel", "arrow", "autoComplete", "autofill", "autoFocus", "CardLogo", "cardNumberField", "children", "defaultValue", "disabled", "error", "fieldLink", "fieldLinkAriaLabel", "fieldLinkDisabled", "fieldLinkRole", "fieldTooltip", "fieldTooltipFluidWidth", "fieldTooltipAriaLabel", "focused", "forceControlled", "hasDegradedPerformance", "hovered", "icon", "id", "isUnderlined", "isObfuscated", "tooltipActive", "iconTooltip", "inputRef", "keyboardFocused", "keyboardType", "label", "loading", "maxLength", "name", "onBlur", "onChange", "onClick", "onComponentRef", "onDisabledClick", "onFocus", "onPressIn", "onPressOut", "onEnter", "onFieldLinkClick", "onFieldTooltipClick", "onKeyDown", "onMouseDown", "onMouseOut", "onMouseOver", "onMouseUp", "onPress", "onTab", "onTouchEnd", "onTouchStart", "obfuscatedValue", "position", "pressed", "readOnly", "spellCheck", "squareBottomBorder", "stack", "tabIndex", "testID", "type", "UNSAFE_inputProps", "UNSAFE_width", "value", "warning", "width"],
  _excluded2 = ["onAnimationStart"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from 'react';
import { useDesignVersion } from '@bubble-ui/provider-design-version';
import View from '@bubble-ui/primitive-view';
import FieldTooltipParticle from '@bubble-ui/temp-field-tooltip';
import { FieldLabel } from '@bubble-ui/atom-field-label';
import TextInput from '@bubble-ui/primitive-text-input';
import FieldLinkParticle from '@bubble-ui/temp-field-link';
import { isNative, platformSelect } from '@bubble-ui/util-platform';
import reformatObfuscation from '@bubble-ui/util-reformat-obfuscation';
import Loader from '@bubble-ui/molecule-loader';
import Link from '@bubble-ui/molecule-link';
import SpacerVertical from '@bubble-ui/atom-spacer-vertical';
import Text from '@bubble-ui/primitive-text';
import { DesignContextForwardProvider, useDesignContext } from '@klarna/designtokens';
import { usePreventDefaultHandler } from '@bubble-ui/hook-use-prevent-default-handler';
import usePropDeprecationWarning from '@bubble-ui/hook-use-prop-deprecation-warning';
import useUncontrolledProp from '@bubble-ui/hook-use-uncontrolled-prop';
import useStyleSheet from '@bubble-ui/hook-use-stylesheet';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
// @ts-expect-error
import withAutofillProps from '@bubble-ui/hoc-with-autofill-props';
import { useUniqueFormIdentifier } from '@bubble-ui/hook-use-unique-form-identifier';
import { useInteractiveStateCombined } from '@bubble-ui/hook-use-interactive-state';
import useOnTabAndOnEnter from '@bubble-ui/hook-use-on-tab-and-on-enter';
import { usePropsSpreadingDeprecationWarning } from '@bubble-ui/hook-use-props-spreading-deprecation-warning';
import { defaultDesignTokens } from './defaultDesignTokens';
import { getDefaultStyleSheet } from './getDefaultStyleSheet';
import { getIds } from './getIds';
var Field = _ref => {
  var {
      accessibilityLabel,
      arrow,
      autoComplete,
      autofill,
      autoFocus,
      CardLogo,
      cardNumberField,
      children,
      defaultValue = '',
      disabled,
      error,
      fieldLink,
      fieldLinkAriaLabel,
      fieldLinkDisabled,
      fieldLinkRole,
      fieldTooltip,
      fieldTooltipFluidWidth,
      fieldTooltipAriaLabel,
      focused,
      forceControlled,
      hasDegradedPerformance,
      hovered,
      icon,
      id,
      isUnderlined,
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      isObfuscated,
      tooltipActive,
      iconTooltip,
      inputRef,
      keyboardFocused,
      keyboardType,
      label,
      loading,
      maxLength,
      name,
      onBlur,
      onChange,
      onClick,
      onComponentRef,
      onDisabledClick,
      onFocus,
      onPressIn,
      onPressOut,
      onEnter,
      onFieldLinkClick,
      onFieldTooltipClick,
      onKeyDown,
      onMouseDown,
      onMouseOut,
      onMouseOver,
      onMouseUp,
      onPress,
      onTab,
      onTouchEnd,
      onTouchStart,
      obfuscatedValue,
      position,
      pressed,
      readOnly,
      spellCheck,
      squareBottomBorder,
      stack,
      tabIndex,
      testID,
      type,
      UNSAFE_inputProps,
      UNSAFE_width,
      value,
      warning,
      width
      /**
       * @deprecated props spreading is outdated and will be removed with v7.0.0
       */
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  usePropDeprecationWarning({
    componentName: 'Field',
    propName: 'onFieldTooltipClick',
    shouldWarn: onFieldTooltipClick !== undefined,
    removalDate: 'v6.0.0'
  });
  usePropDeprecationWarning({
    componentName: 'Field',
    propName: 'hasDegradedPerformance',
    shouldWarn: hasDegradedPerformance !== undefined,
    removalDate: 'v6.0.0'
  });
  usePropDeprecationWarning({
    componentName: 'Field',
    propName: 'onFieldTooltipClick',
    shouldWarn: onFieldTooltipClick !== undefined,
    removalDate: 'v6.0.0'
  });
  usePropDeprecationWarning({
    componentName: 'Field',
    propName: 'hasDegradedPerformance',
    shouldWarn: hasDegradedPerformance !== undefined,
    removalDate: 'v6.0.0'
  });
  usePropDeprecationWarning({
    componentName: 'Field',
    propName: 'isUnderlined',
    shouldWarn: isUnderlined !== undefined,
    removalDate: 'v6.0.0'
  });
  usePropDeprecationWarning({
    componentName: 'Field',
    propName: 'forceControlled',
    shouldWarn: forceControlled !== undefined,
    removalDate: 'v6.0.0'
  });
  var {
      // @ts-expect-error Needed for withAutofillProps
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      onAnimationStart
    } = props,
    propsToThrowWarning = _objectWithoutProperties(props, _excluded2);
  usePropsSpreadingDeprecationWarning({
    componentName: 'Field',
    props: propsToThrowWarning,
    useInstead: 'UNSAFE_inputProps',
    removalDate: 'v7.0.0'
  });
  var [isTooltipActive, onActive] = useUncontrolledProp({
    prop: tooltipActive
  });
  var [fieldValue, setFieldValue] = useUncontrolledProp({
    prop: value,
    defaultProp: defaultValue,
    onChange
  });
  var onFieldLinkClickPreventDefault = usePreventDefaultHandler(onFieldLinkClick);
  var onFieldTooltipClickPreventDefault = usePreventDefaultHandler(onFieldTooltipClick);
  var designVersion = useDesignVersion();
  var designContext = useDesignContext(defaultDesignTokens);
  Field.displayName = 'Field';
  var componentName = useUniqueFormIdentifier({
    name,
    fallbackName: 'Field'
  });
  var hasLabel = Boolean(label && label.length > 0);
  var hasValue = Boolean(fieldValue && fieldValue.length > 0);
  var reformattedObfuscatedValue = hasDegradedPerformance ? obfuscatedValue : reformatObfuscation(obfuscatedValue);
  var [interactiveState, eventHandlers] = useInteractiveStateCombined(_objectSpread(_objectSpread({}, props), {}, {
    disabled,
    focused,
    hovered,
    keyboardFocused,
    onBlur,
    onFocus,
    onMouseDown,
    onMouseOut,
    onMouseOver,
    onMouseUp,
    onPressIn,
    onPressOut,
    onTouchEnd,
    onTouchStart,
    pressed
  }));
  var onKeyDownEventHandler = useOnTabAndOnEnter({
    onEnter,
    onKeyDown,
    onTab
  });
  var ids = getIds(id);
  var {
    rootStyle,
    cardLogoStyle,
    containerStyle,
    iconColorStyle,
    cardWrapperStyle,
    iconStyle,
    inputStyle,
    fieldLabelWrapperStyle,
    fieldLabelProps,
    loaderStyle,
    textWrapperStyle,
    linkWrapperStyle,
    paragraphSecondaryCorrectFootprintStyle
    // ⚠️ THIS COMPONENT SUPPORTS STYLE SHEET OVERRIDES ⚠️
    // Keep passing all props to the style sheet, even if we don't use them ourselves
  } = useStyleSheet(Field, getDefaultStyleSheet, _objectSpread(_objectSpread({}, props), {}, {
    accessibilityLabel,
    arrow,
    autoComplete,
    autofill,
    autoFocus,
    CardLogo,
    cardNumberField,
    children,
    defaultValue,
    designContext,
    designVersion,
    disabled: interactiveState.disabled,
    error,
    fieldLink,
    fieldLinkAriaLabel,
    fieldLinkDisabled,
    fieldLinkRole,
    fieldTooltip,
    fieldTooltipFluidWidth,
    fieldTooltipAriaLabel,
    focused: interactiveState.focused,
    forceControlled,
    hasDegradedPerformance,
    hasLabel,
    hasValue,
    hovered: interactiveState.hovered,
    icon,
    id,
    isUnderlined,
    obfuscatedValue: reformattedObfuscatedValue,
    onComponentRef,
    iconTooltip,
    inputRef,
    keyboardFocused: interactiveState.keyboardFocused,
    keyboardType,
    label,
    loading,
    maxLength,
    name,
    onBlur,
    onChange,
    onClick,
    onDisabledClick,
    onEnter,
    onFieldLinkClick,
    onFieldTooltipClick,
    onFocus,
    onMouseDown,
    onMouseOut,
    onMouseOver,
    onMouseUp,
    onPress,
    onPressIn,
    onPressOut,
    onKeyDown,
    onTab,
    onTouchEnd,
    onTouchStart,
    position,
    pressed: interactiveState.pressed,
    readOnly,
    spellCheck,
    squareBottomBorder,
    stack,
    tabIndex,
    testID,
    tooltipActive: isTooltipActive,
    type,
    UNSAFE_inputProps,
    UNSAFE_width,
    value,
    warning,
    width
  }));
  return /*#__PURE__*/React.createElement(View, {
    id: ids === null || ids === void 0 ? void 0 : ids.root,
    style: rootStyle
  }, /*#__PURE__*/React.createElement(View, {
    id: ids === null || ids === void 0 ? void 0 : ids.container,
    tag: "label",
    accessibilityState: {
      disabled: interactiveState.disabled
    },
    htmlFor: (ids === null || ids === void 0 ? void 0 : ids.input) || componentName,
    onClick: e => interactiveState.disabled && onDisabledClick && onDisabledClick(e),
    style: containerStyle
  }, (icon || CardLogo) && /*#__PURE__*/React.createElement(View, {
    style: cardWrapperStyle
  }, CardLogo && /*#__PURE__*/React.createElement(View, {
    id: ids === null || ids === void 0 ? void 0 : ids.cardLogo,
    style: cardLogoStyle
  }, /*#__PURE__*/React.createElement(CardLogo, null)), icon && !CardLogo && /*#__PURE__*/React.createElement(View, {
    id: ids === null || ids === void 0 ? void 0 : ids.icon,
    style: iconStyle
  }, /*#__PURE__*/React.createElement(DesignContextForwardProvider, {
    context: designContext
  }, /*#__PURE__*/React.cloneElement(icon, iconColorStyle)))), /*#__PURE__*/React.createElement(View, {
    id: ids === null || ids === void 0 ? void 0 : ids.textWrapper,
    style: textWrapperStyle
  }, label && label !== '' && /*#__PURE__*/React.createElement(View, {
    style: fieldLabelWrapperStyle
  }, /*#__PURE__*/React.createElement(DesignContextForwardProvider, {
    context: designContext
  }, /*#__PURE__*/React.createElement(FieldLabel, _extends({
    id: ids === null || ids === void 0 ? void 0 : ids.label,
    error: error,
    warning: warning
  }, fieldLabelProps), label))), /*#__PURE__*/React.createElement(TextInput, _extends({
    id: (ids === null || ids === void 0 ? void 0 : ids.input) || componentName,
    testID: testID
  }, UNSAFE_inputProps, platformSelect({
    ios: {
      selectionColor: inputStyle.caretColor
    },
    android: {},
    web: {}
  }), {
    accessibilityLabel: accessibilityLabel || label,
    autoComplete: autoComplete,
    autoFocus: autoFocus,
    disabled: interactiveState.disabled,
    inputRef: inputRef,
    keyboardType: keyboardType,
    maxLength: maxLength,
    name: componentName,
    onChange: setFieldValue,
    onClick: onClick,
    onPress: onPress
  }, onComponentRef ? {
    onComponentRef
  } : {}, {
    readOnly: readOnly,
    spellCheck: spellCheck,
    style: inputStyle,
    tabIndex: tabIndex,
    type: type,
    value: reformattedObfuscatedValue && reformattedObfuscatedValue !== '' ? reformattedObfuscatedValue : fieldValue
  }, isNative ? {
    onEnter,
    onKeyDown
  } : {
    onKeyDown: onKeyDownEventHandler
  }, props, hasDegradedPerformance ? {} : eventHandlers), children)), loading && /*#__PURE__*/React.createElement(View, {
    id: ids === null || ids === void 0 ? void 0 : ids.loader,
    style: loaderStyle
  }, /*#__PURE__*/React.createElement(Loader, null)), fieldLink && !hasDegradedPerformance && /*#__PURE__*/React.createElement(View, {
    id: ids === null || ids === void 0 ? void 0 : ids.fieldLinkWrapper,
    style: linkWrapperStyle
  }, /*#__PURE__*/React.createElement(DesignContextForwardProvider, {
    context: designContext
  }, /*#__PURE__*/React.createElement(FieldLinkParticle, {
    colorToken: "field/link-text-color",
    colorTokenArgs: {
      backgroundState: (error || warning) && !interactiveState.focused || autofill || interactiveState.disabled && !fieldLinkDisabled ? 'tinted' : 'default'
    },
    disabled: fieldLinkDisabled,
    ariaLabel: fieldLinkAriaLabel,
    role: fieldLinkRole,
    textToken: "field/link-text-style",
    id: ids === null || ids === void 0 ? void 0 : ids.fieldLink,
    onClick: onFieldLinkClickPreventDefault
  }, fieldLink)))), fieldTooltip && /*#__PURE__*/React.createElement(FieldTooltipParticle, {
    icon: iconTooltip,
    id: ids === null || ids === void 0 ? void 0 : ids.fieldTooltip,
    disabled: interactiveState.disabled,
    arrow: arrow,
    autofill: autofill,
    error: error,
    hasFluidWidth: fieldTooltipFluidWidth,
    fieldTooltip: fieldTooltip,
    onActive: onActive,
    onClick: onFieldTooltipClickPreventDefault,
    warning: warning,
    ariaLabel: fieldTooltipAriaLabel,
    withPadding: !isUnderlined
  }), fieldLink && hasDegradedPerformance && /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(SpacerVertical, {
    spaceToken: "space/150"
  }), /*#__PURE__*/React.createElement(Text, _extends({}, isNative ? {
    numberOfLines: 0
  } : {}, {
    tag: "paragraph",
    style: paragraphSecondaryCorrectFootprintStyle
  }), /*#__PURE__*/React.createElement(Link, {
    isUnderlined: true,
    disabled: fieldLinkDisabled,
    id: ids === null || ids === void 0 ? void 0 : ids.fieldLink,
    onPress: onFieldLinkClickPreventDefault,
    ariaLabel: fieldLinkAriaLabel,
    role: fieldLinkRole
  }, fieldLink)), /*#__PURE__*/React.createElement(SpacerVertical, {
    spaceToken: "space/50"
  })));
};
Field.displayName = 'Field';
var FieldRegular = withAutofillProps({
  autofill: true
})(Field);
FieldRegular.displayName = 'Field';
export default withProvisionalOverrideFromContext(FieldRegular);
//# sourceMappingURL=index.js.map